import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

enum CategoryFilterType {
    TEXT = "text",
    SELECT = "select",
    NUMBER = "number",
    BOOLEAN = "boolean",
    COLOR = "color",
    RATING = "rating",
    IMAGE = "image"
}

class Feature {
    type: CategoryFilterType;
    name: string;
    value: any;
}

class FeatureGroup {
    name: string;
    features: Feature[];
}

export class GetProductFeaturesResponse {
    feature_groups: FeatureGroup[];
}

export function getProductFeatures (product_id: string): Promise<AxiosResponse<GetProductFeaturesResponse>> {
    const query = `/product/${product_id}/features`
    return Cirus.get(query);
}